module.exports = __webpack_public_path__ + "static/media/nitcerti_logo.0fb0a3e8.png";